const SCROLL_THRESHOLD_PX = 70;

/** Bandeau logo sticky au scroll (order page + confirmation). */
export function bindOrderPageNavbarScroll(options = {}) {
  const threshold =
    typeof options.threshold === "number"
      ? options.threshold
      : SCROLL_THRESHOLD_PX;

  if (window.__vgOrderPageNavbarScrollBound) {
    return;
  }

  window.__vgOrderPageNavbarScrollBound = true;

  const updateNavbar = () => {
    const navbar = document.querySelector(".left_nav_items");
    if (!navbar) {
      return;
    }

    navbar.classList.toggle("navbar-scrolled", window.scrollY > threshold);
  };

  window.addEventListener("scroll", updateNavbar, { passive: true });
  updateNavbar();
}
